import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColumnFilter, ColumnSort } from "@tanstack/react-table";
import { INITIAL_PAGING, STATUS_INITIAL, STATUS_LOADING, STATUS_SUCCEEDED } from "myParkdUtils/constants";
import { MinimalUser, PagingReactTable, Status } from "types";


export type CompanyUsersState = {
    companyUsers: MinimalUser[],
    paging: PagingReactTable,
    usersGetStatus: Status,
    userUpdateStatus: Status
}

export const initialCompanyUsersState: CompanyUsersState = {
    companyUsers: [],
    paging: INITIAL_PAGING,
    usersGetStatus: STATUS_INITIAL,
    userUpdateStatus: STATUS_INITIAL
};

export const replaceUserInList = (users: MinimalUser[], updatedUser: MinimalUser) => {
    return users.map(user =>
        user.publicId === updatedUser.publicId ? updatedUser : user
    )
}

export const removeUserFromList = (users: MinimalUser[], deletedUserPublicId: string) => {
    return users.filter(user => user.publicId !== deletedUserPublicId);
}

export const companyUsersSlice = createSlice({
    name: 'companyUsers',
    initialState: initialCompanyUsersState,
    reducers: {
        getCompanyUsers(state, action: PayloadAction<{ paging: PagingReactTable, filters?: ColumnFilter[], sorting?: ColumnSort[] }>) {
            state.usersGetStatus = STATUS_LOADING;
            state.companyUsers = [];
            state.paging.currentPage = action.payload.paging.currentPage;
            state.paging.pageSize = action.payload.paging.pageSize;
        },
        getCompanyUsersCompleted(state, action: PayloadAction<{ users: MinimalUser[], totalElements: number, totalPages: number }>) {
            state.usersGetStatus = STATUS_SUCCEEDED;
            state.companyUsers = action.payload.users;
            state.paging.totalElements = action.payload.totalElements;
            state.paging.totalPages = action.payload.totalPages;
        },
        getCompanyUsersError(state, action: PayloadAction<{ error: any }>) {
            state.usersGetStatus = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        },

        updateCompanyUser(state, action: PayloadAction<{ user: MinimalUser }>) {
            state.userUpdateStatus = STATUS_LOADING
        },
        updateCompanyUserCompleted(state, action: PayloadAction<{ user: MinimalUser }>) {
            state.userUpdateStatus = STATUS_SUCCEEDED;
            state.companyUsers = replaceUserInList(state.companyUsers, action.payload.user);
        },
        updateCompanyUserError(state, action: PayloadAction<{ error: any }>) {
            state.userUpdateStatus = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        },
        clearUserUpdateStatus(state) {
            state.userUpdateStatus = initialCompanyUsersState.userUpdateStatus
        },

        deleteCompanyUser(state, action: PayloadAction<{ userPublicId: string }>) {
            state.userUpdateStatus = STATUS_LOADING
        },
        deleteCompanyUserCompleted(state, action: PayloadAction<{ userPublicId: string }>) {
            state.userUpdateStatus = STATUS_SUCCEEDED;
            state.companyUsers = removeUserFromList(state.companyUsers, action.payload.userPublicId);
        },
        deleteCompanyUserError(state, action: PayloadAction<{ error: any }>) {
            state.userUpdateStatus = {
                ...STATUS_INITIAL,
                error: action.payload.error
            }
        }

    }

});

export const companyUsersSliceActions = companyUsersSlice.actions;

export default companyUsersSlice.reducer;